import { array, boolean, coerce, create, Describe, number, optional, string, type } from 'superstruct';

import { Job, JobDownloadFormat } from '~extension/web2print/model/Job';
import { JobList, JobListClient } from '~extension/web2print/model/JobList';

export const JobDownloadFormatValidator: Describe<JobDownloadFormat> = type({
  id: optional(number()),
  name: string(),
  description: string(),
});

export const JobValidator: Describe<Job> = type({
  jobId: number(),
  step: string(),
  status: string(),
  type: string(),
  clientId: number(),
  documentId: number(),
  parentId: number(),
  assetId: coerce(string(), number(), val => `${val}`),
  documentName: string(),
  lastedit: string(),
  actions: array(string()),
  downloadFormats: array(JobDownloadFormatValidator),
  isOutdated: boolean(),
});

export const JobListClientValidator: Describe<JobListClient> = type({
  name: string(),
  id: number(),
  jobs: array(JobValidator),
});

export const JobListValidator: Describe<JobList> = type({
  host: string(),
  clients: array(JobListClientValidator),
});

export function makeJobList(raw: unknown) {
  try {
    const jobList = create(raw, JobListValidator);
    return jobList;
  } catch (err) {
    console.error(err);
  }
}
